import { render, staticRenderFns } from "./ProfileMarketSegment.vue?vue&type=template&id=50651360"
import script from "./ProfileMarketSegment.vue?vue&type=script&lang=js"
export * from "./ProfileMarketSegment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports